export default __webpack_public_path__ + "static/media/checkin.861699da.svg";